<section class="container home-swiper">
  <div class="row bottom-xs">
    <div class="col-xs-12 col-md-6">
      <swiper #swiper [config]="config">
        <ng-template swiperSlide class="asdf-slide">
          <picture>
            <source srcset="/assets/images/homepage-slider/mobile/mmFrenchToastBreadPudding_001.webp" media="(max-width: 450px)">
            <source srcset="/assets/images/homepage-slider/mobile/mmFrenchToastBreadPudding_001.jpg" media="(max-width: 450px)">
            <source srcset="/assets/images/homepage-slider/tablet/FrenchToastBreadPudding_001.webp" media="(max-width: 1024px)">
            <source srcset="/assets/images/homepage-slider/tablet/FrenchToastBreadPudding_001.jpg" media="(max-width: 1024px)">
            <source srcset="/assets/images/homepage-slider/desktop/FrenchToastBreadPudding_001@2x.webp">
            <img src="/assets/images/homepage-slider/desktop/FrenchToastBreadPudding_001@2x.jpg" alt="Chef sprinkles powdered sugar on berries and coffee cake."/>
          </picture>
        </ng-template>
        <ng-template swiperSlide>
          <picture>
            <source srcset="/assets/images/homepage-slider/mobile/mmVeganChocolateCake_010.webp" media="(max-width: 450px)">
            <source srcset="/assets/images/homepage-slider/mobile/mmVeganChocolateCake_010.jpg" media="(max-width: 450px)">
            <source srcset="/assets/images/homepage-slider/tablet/VeganChocolateCake_010.webp" media="(max-width: 1024px)">
            <source srcset="/assets/images/homepage-slider/tablet/VeganChocolateCake_010.web.jpg" media="(max-width: 1024px)">
            <source srcset="/assets/images/homepage-slider/desktop/VeganChocolateCake_010@2x.webp">
            <img src="/assets/images/homepage-slider/desktop/VeganChocolateCake_010@2x.jpg" alt="Chef sprinkles chocolate shavings on vegan chocolate cake."/>
          </picture>
        </ng-template>
        <ng-template swiperSlide>
          <picture>
            <source srcset="/assets/images/homepage-slider/mobile/mmCateringJul19(53).webp" media="(max-width: 450px)">
            <source srcset="/assets/images/homepage-slider/mobile/mmCateringJul19(53).jpg" media="(max-width: 450px)">
            <source srcset="/assets/images/homepage-slider/tablet/CateringJul19(53).webp" media="(max-width: 1024px)">
            <source srcset="/assets/images/homepage-slider/tablet/CateringJul19(53).web.jpg" media="(max-width: 1024px)">
            <source srcset="/assets/images/homepage-slider/desktop/CateringJul19(53)@2x.webp">
            <img src="/assets/images/homepage-slider/desktop/CateringJul19(53)@2x.jpg" alt="Pasta with asparagus, herbs, and Parmasan."/>
          </picture>
        </ng-template>
        <ng-template swiperSlide>
          <picture>
            <source srcset="/assets/images/homepage-slider/mobile/mmBruschetta_004.webp" media="(max-width: 450px)">
            <source srcset="/assets/images/homepage-slider/mobile/mmBruschetta_004.jpg" media="(max-width: 450px)">
            <source srcset="/assets/images/homepage-slider/tablet/Bruschetta_004.webp" media="(max-width: 1024px)">
            <source srcset="/assets/images/homepage-slider/tablet/Bruschetta_004.web.jpg" media="(max-width: 1024px)">
            <source srcset="/assets/images/homepage-slider/desktop/Bruschetta_004@2x.webp">
            <img src="/assets/images/homepage-slider/desktop/Bruschetta_004@2x.jpg" alt="Chef arranges local Ann Arbor blueberries on bruschetta with cream cheese."/>
          </picture>
        </ng-template>
        <ng-template swiperSlide>
          <picture>
            <source srcset="/assets/images/homepage-slider/mobile/mmCateringJul19(43).webp" media="(max-width: 450px)">
            <source srcset="/assets/images/homepage-slider/mobile/mmCateringJul19(43).jpg" media="(max-width: 450px)">
            <source srcset="/assets/images/homepage-slider/tablet/CateringJul19(43).webp" media="(max-width: 1024px)">
            <source srcset="/assets/images/homepage-slider/tablet/CateringJul19(43).web.jpg" media="(max-width: 1024px)">
            <source srcset="/assets/images/homepage-slider/desktop/CateringJul19(43)@2x.webp">
            <img src="/assets/images/homepage-slider/desktop/CateringJul19(43)@2x.jpg" alt="Bean salad with red and yellow peppers and herbs."/>
          </picture>
        </ng-template>
        <button slot="container-end" (click)=toggleAutoplay() [attr.aria-pressed]="autoplayPause" class="autoplayControl" aria-label="Pause Slider'">
          <mat-icon *ngIf="!autoplayPause">pause_circle</mat-icon>
          <mat-icon *ngIf="autoplayPause">play_circle</mat-icon>
        </button>
      </swiper>
    </div>
    <div class="col-xs-12 col-md-6">
      <section class="box">
        <h1>Celebrate with extraordinary taste.</h1>
        <p>Let&apos;s create a one-of-a-kind event you&apos;ll never forget.</p>
      </section>
    </div>
  </div>
</section>
<section class="testimonials">
  <div class="container">
    <button class="prev arrow"></button>
    <button class="next arrow right"></button>
    <swiper #testimonials [config]="testimonialsConfig">
      <ng-template swiperSlide>
        <div class="testimonial container row middle-xs pad">
          <div class="testimonial-image col-xs-12 col-sm-12 col-md-7">
            <picture>
              <source srcset="/assets/images/homepage-quotes/grid.webp">
              <img loading="lazy" src="/assets/images/homepage-quotes/grid.png" alt="Salmon and cucumber hors d'oeuvres. Groom and bride on Ann Arbor campus. Fork stuck in breaded salmon.">
            </picture>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-5">
            <blockquote class="box testimonial-text">
              <p>Everything on the menu is in-season. Everything is fresh. And everyone who works here believes in authentic food served with care.</p>
              <span>Iris and John</span>
            </blockquote>
          </div>
        </div>
      </ng-template>
      <ng-template swiperSlide>
        <div class="testimonial container row middle-xs pad">
          <div class="testimonial-image col-xs-12 col-sm-12 col-md-7">
            <picture>
              <source srcset="/assets/images/homepage-quotes/HealthierSidePlatter.webp">
              <img loading="lazy" src="/assets/images/homepage-quotes/HealthierSidePlatter.jpg" alt="Table display with bagels and bowls of jam and peanut butter.">
            </picture>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-5">
            <blockquote>
              <p>Both our breakfast and lunch buffet today was wonderful. Thank you so much to you and your staff. Everything went great and we were thrilled with the food and the service provided by your team.</p>
              <span>Brad</span>
            </blockquote>
          </div>
        </div>
      </ng-template>
    </swiper>
  </div>
</section>
<section>
  <div class="container team">
    <h2>Meet our team</h2>
    <app-team [count]="3"></app-team>
    <div class="row end-md">
      <div class="col-xs-12">
        <div class="box">
          <a class="link" routerLink="/about" fragment="team">View More About Our Team.</a>
        </div>
      </div>
    </div>

  </div>
</section>
<section>
  <div class="container">
  <h2>Our sustainability story</h2>
    <div class="row">
      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
        <div class="box">
          <mat-icon>restaurant</mat-icon>
          <h3 class="font-size-3 no-pad">Plant-based recipes.</h3>
          <p>Our chefs have crafted a low-carbon menu to support the health of our planet and your guests.</p>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
        <div class="box">
          <mat-icon>compost</mat-icon>
          <h3 class="font-size-3 no-pad">Composting.</h3>
          <p>By collecting our food scraps for local composting, we reduce the amount of waste that ends up in the landfill.</p>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
        <div class="box">
          <mat-icon>recycling</mat-icon>
          <h3 class="font-size-3 no-pad">Zero waste.</h3>
          <p>We support zero waste initiatives by offering compostable paper products and compost bins for your event.</p>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
        <div class="box">
          <mat-icon>agriculture</mat-icon>
          <h3 class="font-size-3 no-pad">Local purchasing.</h3>
          <p>When possible we use local ingredients, including fresh vegetables grown by students on our campus farm.</p>
        </div>
      </div>
    </div>
    <div class="hr-box">
      <a class="link" routerLink="/about">Learn more about how we serve.</a>
    </div>
  </div>
</section>
